module.exports = __webpack_public_path__ + "media/assets/images/decimalpoint-92edbd0ca7c4d21562c010e9ee9528f2.png";